import React from 'react'
import logo from './logo png.png'
import {
  Link
} from "react-router-dom";

export default function Navbar(props) {
  return (
   <>
  <header className="text-gray-600 body-font">
  <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
    <a className="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0">
      <img className="h-8 w-auto sm:h-10" src={logo} alt=""></img>
      <span className="ml-3 text-xl">{props.title}</span>
    </a>
    <nav className="md:ml-auto md:mr-auto flex flex-wrap items-center text-base justify-center">
      <Link className="mr-5 hover:text-gray-900" to='/'>Home</Link>
      <Link className="mr-5 hover:text-gray-900" to='/about'>Our Story</Link>
      <Link className="mr-5 hover:text-gray-900" to='/contactUs'>Get in touch</Link>
      {/* <Link className="mr-5 hover:text-gray-900" to='/blogs'>Blogs</Link> */}
      
      
    </nav>
    <a href="https://heyzine.com/flip-book/675090f7ec.html" target='_blank'>

    <button class="inline-flex items-center bg-gray-100 border-2 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-4 md:mt-0" onClick={"mailto:examlpe@m.com"}>Brochure
      <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-1" viewBox="0 0 24 24">
        <path d="M5 12h14M12 5l7 7-7 7"></path>
      </svg>
    
    </button>
    </a>
  </div>
</header>

   </>
  )
}
